"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCaptchProviderByType = exports.selectHuaweiCaptchaInfo = exports.selectYandexCaptchaInfo = exports.selectGoogleCaptchaInfo = exports.selectActiveCaptchaProvider = void 0;
const selectCaptchaContainerState = (state) => state.captchaContainerState;
const selectActiveCaptchaProvider = (state) => selectCaptchaContainerState(state).activeCaptchaProvider;
exports.selectActiveCaptchaProvider = selectActiveCaptchaProvider;
const selectGoogleCaptchaInfo = (state) => selectCaptchaContainerState(state).googleCaptchaInfo;
exports.selectGoogleCaptchaInfo = selectGoogleCaptchaInfo;
const selectYandexCaptchaInfo = (state) => selectCaptchaContainerState(state).yandexCaptchaInfo;
exports.selectYandexCaptchaInfo = selectYandexCaptchaInfo;
const selectHuaweiCaptchaInfo = (state) => selectCaptchaContainerState(state).huaweiCaptchaInfo;
exports.selectHuaweiCaptchaInfo = selectHuaweiCaptchaInfo;
const selectCaptchProviders = (state) => selectCaptchaContainerState(state).captchaProviders;
const selectCaptchProviderByType = (state, type) => selectCaptchProviders(state).find((provider) => provider.type === type);
exports.selectCaptchProviderByType = selectCaptchProviderByType;
//# sourceMappingURL=selectors.js.map